import { AB_PLATFORM_SSR, AB_PLATFORM_IGNORE } from '@src/config/constants'
import { getAssignedExperimentBuckets } from '@src/experiments'
import { AssignedExperimentBucket } from '@src/experiments/experiments.types'
import pageExperimentManager from '@src/experiments/pageExperiments'
import { statsigExperimentManager } from '@src/experiments/statsig-integration'
import AuthUtil from '@src/quince-site-common/src/utils/authUtil'
import { ANALYTIC_COOKIES } from '@src/quince-site-common/src/utils/constants'
import getCookie from '@src/quince-site-common/src/utils/getCookie'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

const getIsPlatformSSR = (): string[] => {
  if (!isBrowser()) return []
  const platformCookie = getCookie(ANALYTIC_COOKIES.PLATFORM_AB)
  if (platformCookie?.includes('ssr')) return [AB_PLATFORM_SSR]
  if (platformCookie?.includes('ignore')) return [AB_PLATFORM_IGNORE]
  return []
}

const shouldTrackBucketForUser = (experiment: AssignedExperimentBucket): boolean => {
  const loggedInUser = experiment.loggedInUsersOnly && AuthUtil.isLoggedIn()
  const loggedInCondition = !experiment.loggedInUsersOnly || loggedInUser

  return loggedInCondition
}

const getAssignedExperimentBucketsForLogging = () => {
  const assignedExperimentBuckets = getAssignedExperimentBuckets()
  const experimentsToTrack = Object.values(assignedExperimentBuckets)
    .filter(shouldTrackBucketForUser)
    .filter(experiment => experiment.isActive)
  const assignedExpLogs = experimentsToTrack.map(experiment => ({
    experimentName: experiment.name,
    bucketName: experiment.bucket,
  }))

  return assignedExpLogs
}

export const getActiveExperiments = () => {
  const activeExperiments = []

  const experimentBuckets = [
    ...getAssignedExperimentBucketsForLogging(),
    ...pageExperimentManager.getUserBucketsForEventLogging(),
    ...statsigExperimentManager.getActiveExposedBuckets(),
  ]
  for (const experimentBucket of experimentBuckets) {
    activeExperiments.push(`${experimentBucket.experimentName}_${experimentBucket.bucketName}`)
  }

  return [...activeExperiments, ...getIsPlatformSSR()]
}
